import React from "react";
import { Col, Row, Tabs } from 'antd';
import { SecurityScanOutlined } from '@ant-design/icons';
import LoginDetails from '../accounts/LoginDetails';
import PageTitle from '../../../components/page/PageTitle';
import { cardsGridColumn } from "../../../assets/styles";

const Security = () => {
    const tabsItems  = [
        {
            label: 'Login Details',
            key: '1',
            children: (
                <Row gutter={{ sm: 16 }}>
                    <Col {...cardsGridColumn}>
                        <LoginDetails />
                    </Col>
                </Row>
            )
        }
    ];

    return (
        <>
            <PageTitle title="Security" icon={<SecurityScanOutlined />} />
            <Tabs defaultActiveKey="1" items={tabsItems} tabBarGutter={16} />
        </>
    );
};

export default Security;
